import { format, parseISO } from 'date-fns';
export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? '';
export const S3_URL = import.meta.env.VITE_S3_URL ?? '';
export const CURRENCY_SYMBOL = import.meta.env.VITE_CURRENCY_SYMBOL ?? '$';
export const API_BASE_URL = import.meta.env.VITE_API_URL;
export const REFRESH_TOKEN_TIME = import.meta.env.VITE_REFRESH_TOKEN_TIME;
export const PRODUCTION_MODE: boolean =
  import.meta.env.VITE_PRODUCTION_MODE === 'true';
export const DEBUG_MODE: boolean = import.meta.env.VITE_DEBUG_MODE === 'true';
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? '';

export const NO_IMAGE = 'noimage.jpg';

export const ROLE_SLUG = {
  MANAGER: 'admin',
  SUPER_ADMIN: 'superadmin',
  INSTRUCTOR: 'instructoruser',
  MOUNTAIN_MANAGEMENT: 'mountainmanagement'
};

export const LIMIT_DATA = {
  CONFIGURATION_LIST: 10,
  USER_LIST: 10,
  SERVICE_LIST: 10,
  CARS_LIST: 10,
  MOUNTAIN_LIST: 10,
  HOTEL_AGENT_MANAGERS: 10,
  BOOKINGS_LIST: 10,
  BOOKING_USERS_LIST: 10,
  INSTRUCTOR_AGENT_MANAGERS: 10,
  DIET_LIST: 10,
  PARTICIPANTS_LIST: 10
};
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = parseISO(dateString);
  return format(date, 'MM/dd/yyyy');
};

// Generic yes/no options (string)
export const YES_NO_OPTIONS = [
  { value: 'Y', label: 'Yes' },
  { value: 'N', label: 'No' }
];

// Boolean true/false options, labeled as Active/Inactive
export const BOOLEAN_ACTIVE_INACTIVE_OPTIONS = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' }
];

// Numeric Active/Inactive (e.g., 0 = Active)
export const NUMERIC_ACTIVE_INACTIVE_OPTIONS = [
  { value: 1, label: 'Active' },
  { value: 0, label: 'Inactive' }
];

// Numeric Yes/No (e.g., 0 = Yes)
export const NUMERIC_YES_NO_OPTIONS = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' }
];

export const REVENUE_TYPE_OPTIONS = [
  { value: 'service', label: 'Calculate By Service' },
  { value: 'participant', label: 'Calculate By Participants' }
];

export const SORT_ORDER_OPTIONS = [
  { value: 'asc', label: 'Ascending' },
  { value: 'desc', label: 'Descending' }
];

export const SERVICE_MODE_OPTIONS = [
  { value: 'private', label: 'Private' },
  { value: 'groups', label: 'Groups' }
];

export const HOTEL_BOOKING_TYPE_OPTIONS = [
  { value: '', label: 'Select Type' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'agent', label: 'Agent' }
];

export const PROCESSING_STATUS_OPTIONS = [
  { value: 'Y', label: 'Processed' },
  { value: 'N', label: 'UnProcessed' },
  { value: 'R', label: 'Rejected' }
];

export const WEEK_DAYS: SelectOption[] = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' }
];

export const rateLevelOptions: SelectOption[] = [
  { value: '', label: 'Select level' },
  ...Array.from({ length: 20 }, (_, i) => ({
    value: i + 1,
    label: `Level ${i + 1}`
  }))
];

type SelectOption = {
  value: string | number;
  placeholder?: string;
  label: string;
};

/* export const CreateArrayOptions = (
  count: number,
  placeholder: string = '',
  labelPrefix: string = ''
): SelectOption[] => {
  return [
    { value: '', label: placeholder },
    ...Array.from({ length: count }, (_, i) => ({
      value: i,
      label: `${labelPrefix} ${i}`
    }))
  ];
}; */

export const CreateArrayOptions = (
  count: number,
  placeholder: string = '',
  labelPrefix: string = ''
): SelectOption[] => {
  const options: SelectOption[] = [];

  // Add placeholder only if not empty
  if (placeholder.trim()) {
    options.push({ value: '', label: placeholder });
  }

  // Add number options starting from 0
  const numberOptions = Array.from({ length: count + 1 }, (_, i) => ({
    value: i,
    label: `${labelPrefix} ${i}`.trim()
  }));

  return [...options, ...numberOptions];
};

export const RANK_TYPE_OPTIONS: SelectOption[] = [
  { value: 'SK', label: 'SK' },
  { value: 'SB', label: 'SB' },
  { value: 'O', label: 'Other' }
];

export const LEVEL_OPTIONS = [
  { value: '', label: 'Select Level' },
  { value: 'SK1', label: 'SK1' },
  { value: 'SK2', label: 'SK2' },
  { value: 'SK3', label: 'SK3' },
  { value: 'SK4', label: 'SK4' },
  { value: 'SK5', label: 'SK5' },
  { value: 'SK6', label: 'SK6' },
  { value: 'SB1', label: 'SB1' },
  { value: 'SB2', label: 'SB2' },
  { value: 'SB3', label: 'SB3' },
  { value: 'SB4', label: 'SB4' },
  { value: 'SB5', label: 'SB5' },
  { value: 'SB6', label: 'SB6' }
];

export const REQ_OPTIONS = [
  { value: 'NA', label: 'NA' },
  { value: 'REQ', label: 'REQ' },
  { value: 'REQM', label: 'REQM' },
  { value: 'REQF', label: 'REQF' },
  { value: 'REQS', label: 'REQS' }
];

export const getDateTimeFn = (dateTimeStr: string, type: string = 'time') => {
  const date = new Date(dateTimeStr);

  if (type === 'date') {
    return date.toISOString().split('T')[0]; // YYYY-MM-DD
  }
  if (type === 'time') {
    return date.toISOString().split('T')[1].slice(0, 5); // HH:MM
  }
  throw new Error('Invalid type. Use "date" or "time".');
};

export const DIET_TYPE_OPTIONS = [
  { value: 'main', label: 'Main' },
  { value: 'side', label: 'Side' }
] as const;

/**
 * Interface for time slots generated at 15-minute intervals.
 */
interface TimeSlot {
  value: string; // e.g., "13:30"
  label: string; // Same as value
  minutes: number; // Minutes since midnight
}

/**
 * Interface for a lesson with start and end times and additional data.
 */
interface Lesson {
  id: number;
  start?: string; // ISO date string or HH:mm format, optional
  end?: string; // ISO date string or HH:mm format, optional
  [key: string]: any; // Allow additional properties
}

/**
 * Interface for a conflict result at a specific time slot.
 */
interface ConflictResult {
  slot: string; // Time slot, e.g., "13:30"
  conflictCount: number; // Number of overlapping lessons
  lessons: Lesson[]; // Full lesson objects
  hasLesson: boolean; // True if at least one lesson is active
}

/**
 * Interface for the analysis result, including conflicts and maximum conflict count.
 */
interface ConflictAnalysis {
  results: ConflictResult[]; // Array of conflict results
  maxConflictCount: number; // Maximum number of overlapping lessons
}

/**
 * Predefined time slots from 08:00 to 22:00 at 15-minute intervals (57 slots).
 */
export const dailyRosterTimeSlot: TimeSlot[] = [
  ...Array.from({ length: ((22 - 8) * 60) / 15 + 1 }, (_, i) => {
    const totalMinutes = 8 * 60 + i * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
    return { value: label, label, minutes: totalMinutes };
  })
];

export const transportRosterTimeSlot: TimeSlot[] = [
  ...Array.from({ length: ((22 - 7) * 60) / 15 + 1 }, (_, i) => {
    const totalMinutes = 7 * 60 + i * 15;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const label = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
    return { value: label, label, minutes: totalMinutes };
  })
];

/**
 * Analyzes lesson conflicts within time slots, returning results for all 57 slots (08:00–22:00)
 * if valid lessons exist, or 13:30–14:00 if no valid lessons. Includes a hasLesson flag.
 * Skips lessons with missing/invalid start/end times and caps end times at 22:00.
 * @param lessons - Array of lessons with start and end times (default: empty array).
 * @returns Object containing sorted conflict results and maximum conflict count.
 * @throws Error if lesson start/end times are invalid or start is not before end.
 */
export function analyzeLessonConflicts(
  lessons: Lesson[] = []
): ConflictAnalysis {
  // Helper function to convert time string to minutes
  const toMinutes = (time: string): number => {
    // so the parser accepts backend values that omit the "T" separator
    if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}(:\d{2})?$/.test(time)) {
      time = time.replace(' ', 'T') + 'Z';
    }
    if (time.includes('T')) {
      const date = new Date(time);
      if (isNaN(date.getTime())) {
        throw new Error(`Invalid ISO date string: ${time}`);
      }
      return date.getUTCHours() * 60 + date.getUTCMinutes();
    }
    const [h, m] = time.split(':').map(Number);
    if (isNaN(h) || isNaN(m) || h < 0 || h > 23 || m < 0 || m > 59) {
      throw new Error(`Invalid time format: ${time}`);
    }
    return h * 60 + m;
  };

  const slotEnd = 22 * 60; // 22:00 (1320 minutes)

  // Handle empty lessons array or no valid lessons
  if (lessons.length === 0) {
    const results = dailyRosterTimeSlot
      // .filter(slot => slot.minutes >= rangeStart && slot.minutes <= rangeEnd)
      .map(slot => ({
        slot: slot.value,
        conflictCount: 0,
        lessons: [],
        hasLesson: false
      }));
    return { results, maxConflictCount: 0 };
  }

  // Cache lesson start/end times and validate
  const lessonIntervals: { lesson: Lesson; start: number; end: number }[] = [];
  const firstSlotMap: Map<number, number> = new Map();
  const base = dailyRosterTimeSlot[0].minutes;
  const step = 15;
  lessons.forEach(lesson => {
    if (!lesson.start || !lesson.end) {
      console.warn(`Lesson ${lesson.id}: Missing start or end time, skipping`);
      return;
    }
    try {
      const start = toMinutes(lesson.start);
      let end = toMinutes(lesson.end);
      if (start >= end) {
        throw new Error(
          `Lesson ${lesson.id}: start time (${lesson.start}, ${start} minutes) ` +
            `must be before end time (${lesson.end}, ${end} minutes)`
        );
      }
      // Cap end time at 22:00 (slotEnd)
      end = Math.min(end, slotEnd);
      const effectiveStart = Math.max(start, base);
      const diff = effectiveStart - base;
      const index = Math.floor((diff + step - 1) / step);
      const firstSlotMinutes = base + index * step;
      if (firstSlotMinutes >= end) {
        console.warn(
          `Lesson ${lesson.id}: Does not overlap any time slot, skipping`
        );
        return;
      }
      lessonIntervals.push({ lesson, start, end });
      firstSlotMap.set(lesson.id, firstSlotMinutes);
    } catch (error) {
      console.warn(
        `Lesson ${lesson.id}: Invalid time format, skipping - ${error}`
      );
    }
  });

  // Handle case where no valid lessons remain
  if (lessonIntervals.length === 0) {
    const results = dailyRosterTimeSlot
      // .filter(slot => slot.minutes >= rangeStart && slot.minutes <= rangeEnd)
      .map(slot => ({
        slot: slot.value,
        conflictCount: 0,
        lessons: [],
        hasLesson: false
      }));
    return { results, maxConflictCount: 0 };
  }

  // Use all slots when valid lessons exist
  const relevantSlots = dailyRosterTimeSlot;

  // Use sweep-line approach to count overlaps
  const events: { time: number; isStart: boolean; lesson: Lesson }[] = [];
  lessonIntervals.forEach(({ lesson, start, end }) => {
    events.push({ time: start, isStart: true, lesson });
    events.push({ time: end, isStart: false, lesson });
  });

  // Sort events by time (end events before start events if times are equal)
  events.sort((a, b) => a.time - b.time || (a.isStart ? 1 : -1));

  const results: ConflictResult[] = [];
  let activeLessons: Lesson[] = [];
  let currentCount = 0;
  let maxConflictCount = 0;
  let eventIndex = 0;

  // Process all time slots
  for (const slot of relevantSlots) {
    // Update active lessons up to this slot's time
    while (
      eventIndex < events.length &&
      events[eventIndex].time <= slot.minutes
    ) {
      const event = events[eventIndex];
      if (event.isStart) {
        activeLessons.push(event.lesson);
        currentCount++;
      } else {
        activeLessons = activeLessons.filter(l => l.id !== event.lesson.id);
        currentCount--;
      }
      maxConflictCount = Math.max(maxConflictCount, currentCount);
      eventIndex++;
    }

    // Include all slots
    results.push({
      slot: slot.value,
      conflictCount: currentCount,
      lessons: activeLessons.map(lesson => {
        const firstMin = firstSlotMap.get(lesson.id);
        if (firstMin === undefined) {
          // Should not happen
          return { ...lesson };
        }
        const slotIndex = (slot.minutes - firstMin) / 15 + 1;
        return { ...lesson, slotIndex };
      }),
      hasLesson: currentCount > 0
    });
  }

  // Sort results by time
  return {
    results: results.sort((a, b) => {
      const [aHours, aMins] = a.slot.split(':').map(Number);
      const [bHours, bMins] = b.slot.split(':').map(Number);
      return aHours * 60 + aMins - (bHours * 60 + bMins);
    }),
    maxConflictCount
  };
}

export const DAILY_ROSTER_RANK_COLOR = {
  SK: '',
  SB: 'blue',
  O: 'red'
};

export const PROCESSED_LESSON_TH = [
  'S.NO.',
  'Instructor',
  'Client',
  'Time',
  'Lesson',
  'Mountain',
  'Hotel',
  'Students AM-PM-FD',
  'Gross',
  'Commission',
  'Level',
  'Net',
  'Action'
];

export const UNPROCESSED_LESSON_TH = [
  'S.NO.',
  'Instructor',
  'Client',
  'Service',
  '# AM',
  '# PM',
  '# FD',
  'Level',
  'Start',
  'End',
  'Agent',
  'CC',
  'Gross',
  'Commission',
  'Net',
  'Ref',
  'Action'
];
